
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
    name: "App",
    setup() {
        const ref1 = ref('a');
        const reactiveO = reactive({
            name: 'reactiveO',
            a: {
                aName: 'reactiveOa'
            }
        });
        const refO = ref({
            name: 'refO',
            a: {
                aName: 'refOa'
            }
        });
        const update = () => {
            console.log(refO);
            ref1.value += '==';
            reactiveO.a.aName += '==';
            refO.value.a.aName += '==';
        }
        return {
            ref1,
            reactiveO,
            refO,
            update,
        };
    }
});
